import React, { useContext } from "react";
import Head from "next/head";
import { ForgotPasswordForm } from "components/Forms/ForgotPassword";
import { CANONICAL_URL_BASE, META_TITLE } from "constants/meta";
import { useRedirectIfLoggedIn } from "hooks/useRedirectIfLoggedIn";
import { generatePageId } from "@pepdirect/v3/helpers/analyticsLogger";
import { PAGE_TYPE_ENUM } from "@pepdirect/v3/types";
import { LogContext } from "context/log";
import st from "./forgotPassword.module.scss";

export default function ForgotPassword(): JSX.Element {
  const { useLogPageView } = useContext(LogContext);
  const title = `Restore password to ${META_TITLE}`;
  useLogPageView({
    pageType: PAGE_TYPE_ENUM.account,
    pageTitle: title,
    pageCategory: undefined,
    id: generatePageId("forgot-password"),
  });

  useRedirectIfLoggedIn();
  return (
    <section className={st.wrapper}>
      <Head>
        <title>Restore password to {META_TITLE}</title>
        <link rel="canonical" href={`${CANONICAL_URL_BASE}/forgot-password`} />
      </Head>
      <ForgotPasswordForm />
    </section>
  );
}
